export const APP_NAME = 'AI Studio'

export const PAGE_SIZES = [10, 25, 50]
export const DEFAULT_PAGE_SIZE = 10

export const SEARCH_DEBOUNCE_MS = 300

export const SORT_DIRECTIONS = { asc: 'asc', desc: 'desc' }

export const ACCESS_TOKEN_KEY = 'studio.access_token'
export const UI_STORAGE_KEY = 'studio.ui'
